var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tabs",
    {
      attrs: { type: "card", editable: "", "before-leave": _vm.handleTips },
      on: { edit: _vm.handleTabsEdit },
      model: {
        value: _vm.editableTabsValue,
        callback: function($$v) {
          _vm.editableTabsValue = $$v
        },
        expression: "editableTabsValue"
      }
    },
    _vm._l(_vm.editableTabs, function(item) {
      return _c(
        "el-tab-pane",
        { key: item.name, attrs: { label: item.title, name: item.name } },
        [
          _c("GroupSkillLayout", {
            ref: "skillLayout",
            refInFor: true,
            attrs: { taskSkill: item.taskSkill }
          })
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }